import isRunningOnClient from './is-running-on-client';

const scrollingElement: Element | undefined = isRunningOnClient
  ? document.scrollingElement || document.documentElement || document.body
  : undefined;

export default scrollingElement;
